import { forwardRef } from 'react'
import './fields.css'
const Checkbox = forwardRef(function Checkbox({ type = 'checkbox', className = '', ...props }, ref) {
    return <input {...props} type={type} ref={ref} className={'uiCheckbox ' + className} />
})
Checkbox.uiField = true
export default Checkbox
